import { ReactNode, useEffect, useState } from 'react';
import { useMap } from 'react-map-gl';
import styled from 'styled-components';
import { ZoomType } from '../../types';
import { useSelector } from 'react-redux';

interface ZoomButtonProps {
  icon: ReactNode;
  type: ZoomType;
  zoom: number;
  handleClick: () => void;
}
const ZoomButton = ({ icon, type, zoom, handleClick }: ZoomButtonProps) => {
  const info = useSelector((state: any) => state.map.info);

  const { current: mapRef } = useMap();

  const [disabled, setDisabled] = useState(
    (type === ZoomType.ZoomIn && zoom === mapRef?.getMaxZoom()) ||
      (type === ZoomType.ZoomOut && zoom === info?.initial_zoom_level)
  );

  useEffect(() => {
    setDisabled(
      (type === ZoomType.ZoomIn && zoom === mapRef?.getMaxZoom()) ||
        (type === ZoomType.ZoomOut && zoom === mapRef?.getMinZoom())
    );
  }, [zoom]);

  return (
    <Container zoomType={type} onClick={handleClick} disabled={disabled}>
      {icon}
    </Container>
  );
};

const Container = styled.button<{ zoomType: string }>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: ${props =>
    props.zoomType === ZoomType.ZoomIn ? '360px 360px 0 0' : '0 0 360px 360px'};
  border: none;
  background-color: #f0f1f3;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);

  :disabled {
    background-color: grey;
    cursor: unset;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 36px;
    height: 36px;
  }
`;

export default ZoomButton;
